import { TipoOrigemDespesaGroupPay } from "./EnumTipoOrigemDespesaGroupPay";

export enum TipoNotaFiscalGroupPay {
  NOTA_FISCAL = "NOTA_FISCAL",
  NOTA_FISCAL_SERVICO = "NOTA_FISCAL_SERVICO",
}

/**
 * Rótulo do documento que sustenta a despesa captada.
 *
 * O Group Pay tem dois fluxos de entrada, e só um deles preenche `tipoNotaFiscal`: a despesa
 * que chega pela notificação de notas fiscais grava NOTA_FISCAL ou NOTA_FISCAL_SERVICO, a que
 * chega pela notificação de boletos não grava nada. O campo nulo, portanto, não é ausência de
 * informação — é a própria informação de que a despesa é de boleto, e é por isso que a origem
 * entra na decisão em vez de o rótulo cair no traço.
 */
export const formatarTipoDocumentoDespesaGroupPay = (
  tipoNotaFiscal?: string | null,
  origemDespesa?: string | null
) => {
  switch (tipoNotaFiscal) {
    case TipoNotaFiscalGroupPay.NOTA_FISCAL:
      return "NF-e";
    case TipoNotaFiscalGroupPay.NOTA_FISCAL_SERVICO:
      return "NFS-e";
    default:
      return ehDespesaDeBoleto(origemDespesa) ? "Boleto" : "-";
  }
};

const ehDespesaDeBoleto = (origemDespesa?: string | null) =>
  origemDespesa === TipoOrigemDespesaGroupPay.BOLETO ||
  origemDespesa === TipoOrigemDespesaGroupPay.MAIL_READER;
